var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4.125l-3.667 3.667-3.666 1.375-1.375 1.375 6.416 6.416 1.375-1.375 1.375-3.666 3.667-3.667",
    fill: "#B191FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4.125l-3.667 3.667-3.666 1.375-1.375 1.375 6.416 6.416 1.375-1.375 1.375-3.666 3.667-3.667M8.25 13.75l-4.125 4.125M13.292 3.667l5.041 5.041",
    stroke: "#303036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgPinFilled;